import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage-layout',
  templateUrl: './homepage-layout.component.html',
  styleUrls: ['./homepage-layout.component.scss']
})
export class HomepageLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
